import React, { Component } from "react";
import PropTypes from "prop-types";

// Redux
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducers from "reducers";

import NoticeMarquee from "components/NoticeMarquee";

class App extends Component {
  static propTypes = {
    initialState: PropTypes.object,
    children: PropTypes.object,
  };

  state = {
    storeLoaded: false,
  };

  componentDidMount() {
    const { initialState = {} } = this.props;
    this.store = createStore(
      reducers,
      { wageDebtors: initialState },
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__(),
    );
    this.setState({ storeLoaded: true });
  }

  render() {
    const { storeLoaded } = this.state;
    if (!storeLoaded) {
      return null;
    }

    return (
      <Provider store={this.store}>
        <React.Fragment>
          <NoticeMarquee />
          {this.props.children}
        </React.Fragment>
      </Provider>
    );
  }
}

export default App;
